var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./liveDiscussionPointsBar.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0af0f32c!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./liveDiscussionPointsBar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/liveDiscussionPointsBar/liveDiscussionPointsBar.vue
// module id = 257
// module chunks = 61